import CrudTable from "@/components/admin/CrudTable";

export default function AdminNewsletter() {
  return (
    <CrudTable
      title="Newsletter Subscribers"
      testid="admin-newsletter"
      endpoint="/admin/newsletter"
      adminEndpoint="/admin/newsletter"
      columns={[
        { key: "email", label: "Email" },
        { key: "created_at", label: "Subscribed", render: (r) => new Date(r.created_at).toLocaleString() },
      ]}
      defaults={{}}
      fields={[]}
    />
  );
}
